export default __webpack_public_path__ + "static/media/bookmark-active.35b8dcb1.svg";